import ghs01 from "@miter/ghs-pictograms/ghs01.svg";
import ghs02 from "@miter/ghs-pictograms/ghs02.svg";
import ghs03 from "@miter/ghs-pictograms/ghs03.svg";
import ghs04 from "@miter/ghs-pictograms/ghs04.svg";
import ghs05 from "@miter/ghs-pictograms/ghs05.svg";
import ghs06 from "@miter/ghs-pictograms/ghs06.svg";
import ghs07 from "@miter/ghs-pictograms/ghs07.svg";
import ghs08 from "@miter/ghs-pictograms/ghs08.svg";
import ghs09 from "@miter/ghs-pictograms/ghs09.svg";
import { GHS_PICTOGRAM_LABELS, type GhsPictogram } from "@miter/types/common";
import { cn } from "ui2";

const PICTOGRAM_SOURCES: Record<GhsPictogram, string> = {
  ghs01,
  ghs02,
  ghs03,
  ghs04,
  ghs05,
  ghs06,
  ghs07,
  ghs08,
  ghs09,
};

export const GhsPictogramGrid = ({
  className,
  pictogramClassName,
  values,
}: {
  className?: string;
  pictogramClassName?: string;
  values?: GhsPictogram[] | null;
}): React.JSX.Element | null => {
  if (!values?.length) return null;

  return (
    <div className={cn("tw:flex tw:flex-wrap tw:gap-1", className)}>
      {values.map((value) => (
        <img
          key={value}
          alt={GHS_PICTOGRAM_LABELS[value]}
          className={cn("tw:size-10 tw:shrink-0", pictogramClassName)}
          src={PICTOGRAM_SOURCES[value]}
        />
      ))}
    </div>
  );
};
